import React from "react";
import Grid from '@mui/material/Grid2';

import { Box, Divider, Stack } from "@mui/material";
import InstanceSelector, {
  InstanceSelectorProps,
} from "@common/components/InstanceSelector";
import Breadcrumb from "../ListDetailViews/common/Breadcrumb";
import { useLocation } from "react-router-dom";

interface TopBannerProps {
  ignoreLocalization?: boolean;
  title?: string;
  instanceSelector?: InstanceSelectorProps;
  children?: React.ReactNode;
  copyUrl?: boolean;
}

const TopBanner = (props: React.PropsWithChildren<TopBannerProps>) => {
  const {
    title,
    instanceSelector,
    children,
    ignoreLocalization = true,
    copyUrl = false,
  } = props;
  const location = useLocation();

  const state = (location.state as { previous?: string }) ?? {};

  return (
    <>
      <Grid
        container
        direction="row"
        wrap="nowrap"
        sx={{ width: '100%', justifyContent: "space-between",
          pr: "1rem", }}
      >
        <Stack
          direction="row"
          sx={{
            alignItems: "center",
            mb: 1,
          }}
        >
          <Breadcrumb
            copyUrl={copyUrl}
            label={title}
            ignoreLocalization={ignoreLocalization}
          />
          {instanceSelector && (
            <Box sx={{ ml: state?.previous ? "1rem" : 0 }}>
              <InstanceSelector label={title} {...instanceSelector} />
            </Box>
          )}
        </Stack>
        {children && children}
      </Grid>
      <Divider orientation="horizontal" />
    </>
  );
};

export default TopBanner;
